import { getSubscriptionDetails } from "../../../../../api/payments/subscriptionsAPI";
import { CHECKOUT_STAGE } from "./checkoutStages";

/**
 * ORCHESTRATION
 * This functionality is to identify the use case. E.g:
 *    1 - Did the user already paid for this service?
 *    2 - It this coming from Stripe redirect, if so route to identify the intent status
 *
 *    Note: if non use case filter is meet, this mean we should render the payment elements, so the return at the end do it.
 * @param {Object} options - The configuration options for the checkout hook.
 * @param {Object} options.service - The service to identify API endpoint and models(E.g: FI -> Financial Insights, TF -> Tax Filing)
 * @param {string|number} options.purchaseId - This is the service id, used for API handling endpoint and models(E.g: subscription id, tax filing id).
 * @param {string|null} options.redirectStatus - This is the Stripe redict status from the payment/setup intent. User to route between payment elements and management(subscribed, processing, error)
 * @returns {Object} An object containing state variables and handler functions to manage the checkout UI.
 */
export async function validateCheckout({
  service,
  purchaseId,
  billingType,
  redirectStatus = false,
  isUpgradeDowngradePlan = false,
}) {
  // ============================================================
  // PROBABLY STRIPE REDIRECT FLOW
  // ============================================================
  if (redirectStatus) {
    return {
      stage: CHECKOUT_STAGE.VERIFYING,
    };
  }

  // ============================================================
  // VALIDATE IF "billingType" IS SUBCRIPTION, AND THE USER HAVE
  // AN ACTIVE SUBSCRIPTION AND "isUpgradeDowngradePlan" IS FALSE
  // THEN WE SHOULD REDIRECT TO ALREADY_SUBSCRIBED STAGE
  // ============================================================
  if (billingType === "RECURRING" && purchaseId) {
    try {
      const response = await getSubscriptionDetails(purchaseId, true);
      if (response.ok) {
        const data = await response.json();

        // Access nested properties based on your API response structure:
        // Let's fallback gracefully if the early adopter engine fields aren't completely setup yet.
        const summary = {
          planName: data.subscription?.plan_name,
          netAmount: data.subscription?.net_amount,
          totalAmount: data.subscription?.total_amount,
          displayLabel: data.subscription?.payment_interval,
          isFreePlan: data.subscription?.plan_name === "Free",
        };

        // If the database states this subscription is already active and verified
        const hasActiveAccess =
          data.subscription?.status === "ACT" || data.status === "ACT";

        if (hasActiveAccess && !isUpgradeDowngradePlan) {
          return {
            stage: CHECKOUT_STAGE.ALREADY_SUBSCRIBED,
            summary,
          };
        }

        // Return standard checkout stage backed by clean backend configuration models
        return {
          stage: CHECKOUT_STAGE.PAYMENT,
          summary,
        };
      }
    } catch (err) {
      console.error(
        "Failed to verify existing subscription status from DB:",
        err,
      );
    }
  }
  /*
      Example future checks:

      - Existing processing intent
      - Existing incomplete payment
      - Expired payment sessions
  */

  return {
    stage: CHECKOUT_STAGE.PAYMENT,
  };
}
